/* globals jQuery */
import 'fitvids.1.1.0'
import 'magnific-popup'

import responsiveNav from './responsive-nav.jquery.js'
import accordion from './jquery.accordion.js'

(($) => {

    $.fn.responsiveNav = responsiveNav
    $.fn.accordion = accordion

    // Make nav menu nice & responsive - responsive-nav.jquery.js
    $('nav.main-nav').responsiveNav({
        closeOnOutsideClick: true,
        showTabsOnFocus: true,
    });

    //make subnav bar to dropdown for mobile
    $('nav.subnav-bar').responsiveNav({
        menuButtonSelector: '.js-subnav-toggle',
        navType: 'dropdown',
        dropdownSelector: 'nav.subnav-bar > ul'
    })

    // Responsive Videos inserted into RTEs - fitvids.1.1.0
    //other video patterns should be wrapped in a div with a class of .video
    $('.rtecontent, .video').fitVids();

    // Accordions - jquery.accordion.js
    $('dl.accordion').accordion();

    //SEARCH POPUP - magnific-popup
    $('.js-open-search').magnificPopup({
        type: 'inline',
        alignTop: true,
        modal: true,
        midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
        mainClass: 'mfp-fade',
        focus: '#s',
        callbacks: {
            // When elemened is focused, some mobile browsers in some cases zoom in
            // It looks not nice, so we disable it:
            beforeOpen: function () {
                if ($(window).width() < 700) {
                    this.st.focus = false;
                } else {
                    this.st.focus = '#s';
                }
            }
        }
    });
    //close the search popup
    $(document).on('click', '.js-close-search', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
    });
    /* END SEARCH CONTROLS */

})(jQuery)
